import React, { Fragment } from 'react'
import Reset from '../Components/Login/ResetPassword' 
function ResetPassword() {
  return (
    <div className="resources">
        <Reset />
    </div>
  )
}

export default ResetPassword